import script from "./NavBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBlock.vue?vue&type=script&setup=true&lang=js"

import "./NavBlock.vue?vue&type=style&index=0&id=e139b0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e139b0d0"]])

export default __exports__